// Semantic keys keep exclusions stable when publication dictionaries use different codes.
export const normalizeExclusions = (keys = []) => [...new Set(keys)].sort();
export const exclusionParams = (keys = []) => keys.length ? { excluded_class_keys: JSON.stringify(normalizeExclusions(keys)) } : {};
export function validateExclusions(data, expected = []) {
  const actual = data?.excluded_class_keys;
  if (actual === undefined && !expected.length) return;
  if (!Array.isArray(actual) || actual.some((key) => typeof key !== 'string' || !key || key.length > 200) ||
      JSON.stringify(actual) !== JSON.stringify(normalizeExclusions(expected))) throw new Error('Invalid CC crop exclusions');
}
